import {AccommodationTaxScheme} from "../../GraphQL/generated/graphql";

export type GeneralSettings = {
    id?: number | null;
    isPersisted: boolean;
    createdAt?: string | null;
    updatedAt?: string | null;
    payeeName: string;
    payeeAddress: string;
    payeeIban: string;
    payeeOib: string;
    registrationVatRate: number;
    accommodationVatRate: number;
    accommodationTaxScheme: AccommodationTaxScheme;
};

export type GeneralSettingsFormValues = {
    payeeName: string;
    payeeAddress: string;
    payeeIban: string;
    payeeOib: string;
    registrationVatPercent: number;
    accommodationPpoPercent: number;
};

export type GeneralSettingsUpsertInput = {
    payeeName: string;
    payeeAddress: string;
    payeeIban: string;
    payeeOib: string;
    registrationVatRate: number;
    accommodationVatRate: number;
    accommodationTaxScheme: AccommodationTaxScheme;
};

export const taxRateToPercent = (rate?: number | null): number => {
    if (!rate || rate <= 0) {
        return 0;
    }

    const percent = rate > 1 ? rate : rate * 100;
    return Number(percent.toFixed(4));
};

export const percentToTaxRate = (percent?: number | null): number => {
    if (!percent || percent <= 0) {
        return 0;
    }

    return Number((percent / 100).toFixed(6));
};

export const generalSettingsToFormValues = (settings: GeneralSettings): GeneralSettingsFormValues => ({
    payeeName: settings.payeeName ?? "",
    payeeAddress: settings.payeeAddress ?? "",
    payeeIban: settings.payeeIban ?? "",
    payeeOib: settings.payeeOib ?? "",
    registrationVatPercent: taxRateToPercent(settings.registrationVatRate),
    accommodationPpoPercent: taxRateToPercent(settings.accommodationVatRate)
});

export const buildGeneralSettingsUpsertInput = (values: GeneralSettingsFormValues): GeneralSettingsUpsertInput => ({
    payeeName: values.payeeName.trim(),
    payeeAddress: values.payeeAddress.trim(),
    payeeIban: values.payeeIban.trim(),
    payeeOib: values.payeeOib.trim(),
    registrationVatRate: percentToTaxRate(values.registrationVatPercent),
    accommodationVatRate: percentToTaxRate(values.accommodationPpoPercent),
    accommodationTaxScheme: AccommodationTaxScheme.Ppo
});
